import React from 'react';
import { useTranslation } from 'react-i18next';
import { NumberInput, Slider } from 'ui-components';
import {
  CALC_OUTCOME_TEST_ID,
  MIN_MONTHLY_INVESTMENT,
  RETIREMENT_CALCULATOR_NAMESPACE,
} from '../../tools/RetirementCalculator.const';
import { useFormatAmount } from '../../tools/useFormatAmount';
import { RetirementCalculatorOutcomeInvestmentPropsModel } from './RetirementCalculatorOutcome.model';

import useStyles from './RetirementCalculatorOutcome.style';

export const RetirementCalculatorOutcomeInvestment: React.FC<
  RetirementCalculatorOutcomeInvestmentPropsModel
> = ({ monthlyInvestment, maxMonthlyInvestment, onMonthlyInvestmentChange }) => {
  const c = useStyles({});
  const [t] = useTranslation(RETIREMENT_CALCULATOR_NAMESPACE, { useSuspense: false });
  const amount = useFormatAmount();

  return (
    <div className={c.investment}>
      <NumberInput
        name="monthlyInvestment"
        className={c.investmentInput}
        label={t('outcome.investment.label')}
        adornment="PLN"
        decimalScale={2}
        fixedDecimalScale={false}
        value={monthlyInvestment}
        onValueChange={value => onMonthlyInvestmentChange(value ?? MIN_MONTHLY_INVESTMENT)}
        testId={`${CALC_OUTCOME_TEST_ID}-investment`}
      />
      <Slider
        className={c.investmentSlider}
        min={MIN_MONTHLY_INVESTMENT}
        max={maxMonthlyInvestment}
        value={Math.min(
          Math.max(monthlyInvestment, MIN_MONTHLY_INVESTMENT),
          maxMonthlyInvestment,
        )}
        onChange={(_event, value) => onMonthlyInvestmentChange(value as number)}
        valueLabelDisplay="on"
        marks={[
          { value: MIN_MONTHLY_INVESTMENT, label: amount(MIN_MONTHLY_INVESTMENT) },
          { value: maxMonthlyInvestment, label: amount(maxMonthlyInvestment) },
        ]}
        testId={`${CALC_OUTCOME_TEST_ID}-slider`}
      />
    </div>
  );
};
